module.exports = __webpack_public_path__ + "Stars-reviews.af333790da6d3696dec1241bd0c55308.png";